import * as React from 'react';
import ContactTypeApiService from '../../../api/ContactTypeApiService';
import Routes from '../../../config/Routes';
import FeatureFlag from '../../../consts/FeatureFlag';
import ContactTypeDTO from '../../../models/ContactTypeDTO';
import BaseDataTableState from '../../../redux/bases/BaseDataTableState';
import AuthorizationUtil from '../../../utils/AuthorizationUtil';
import DateUtil from '../../../utils/DateTimeUtil';
import FileDownload from '../../../utils/FileDownload';
import HistoryUtil from '../../../utils/HistoryUtil';
import DataTable, { DataTableColumnProps, FilterType } from '../core/DataTable';
import DataTableButtonUtil from '../core/DataTableButtonUtil';
import TableRequestDTO from '../core/models/TableRequestDTO';

interface ContactTypeDataTableProps {
}

interface ContactTypeDataTableState extends BaseDataTableState<ContactTypeDTO> {
}

class ContactTypeDataTable extends React.Component<ContactTypeDataTableProps, ContactTypeDataTableState> {
  private _dataTable: DataTable<ContactTypeDTO> | undefined;

  constructor(props: ContactTypeDataTableProps) {
    super(props);
    this.state = {
    };
  }

  private getColumnDefinitions = () => {
    return [
      {
        title: 'Order',
        dataIndex: ContactTypeDTO.displayOrder,
        sorter: true,
        filterType: FilterType.Text,
        width: 75,
      },
      {
        title: 'Name',
        dataIndex: ContactTypeDTO.name,
        sorter: true,
        filterType: FilterType.Text,
      },
    ] as DataTableColumnProps<any>[];
  };

  private openContactType = (record: ContactTypeDTO) => {
    if (record.id) {
      HistoryUtil.push(Routes.generate(Routes.CONTACT_TYPE_DETAILS, { id: record.id }, {}));
    }
  }

  private addContactType = () => {
    HistoryUtil.push(Routes.generate(Routes.NEW_CONTACT_TYPE));
  }

  render() {
    const actionButtons = [];
    actionButtons.push(DataTableButtonUtil.Reset());
    actionButtons.push(
      DataTableButtonUtil.Export(
        (tableRequest: TableRequestDTO) => {
          this.setState({ exporting: true });
          return ContactTypeApiService.getContactTypeDataTableExport(tableRequest).then(file => {
            this.setState({ exporting: false });
            FileDownload.downloadBase64StringAsFile(`Contact_Type_${DateUtil.getDateStamp()}.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', file ?? undefined);
          });
        },
        this.state.exporting
      )
    );

    if (AuthorizationUtil.isAuthorized([FeatureFlag.EDIT_CONTACT_TYPE])) {
      actionButtons.push(DataTableButtonUtil.Default('New Contact Type', () => this.addContactType()));
    }

    return (
      <DataTable
        ref={(element: any) => (this._dataTable = element)}
        onRowClick={this.openContactType}
        serverSide={true}
        tableProps={{
          rowKey: 'id',
          scroll: { x: 500 }
        }}
        globalSearch={true}
        buttonBar={actionButtons}
        columns={this.getColumnDefinitions()}
        fetchData={{
          fetch: (requestState: TableRequestDTO) => ContactTypeApiService.getContactTypeTableData(requestState)
        }}
        stateSaving={{ enabled: true, tableUniqueKey: 'contact_types_list' }} />
    );
  }
}

export default ContactTypeDataTable;
